

import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function AccueilPrestaSkeleton() {
  return (
    <>
      {/* Banner for incomplete establishment */}
      <div className="row mb-32">
        <div className="frame">
          <div className="d-flex justify-content-between align-items-center gap-3 w-100">
            <div className="d-flex align-items-center gap-3">
              <Skeleton circle width={24} height={24} />
              <div>
                <Skeleton width={200} height={20} />
                <Skeleton width={300} height={16} count={2} />
              </div>
            </div>
            <Skeleton width={150} height={40} />
          </div>
        </div>
      </div>

      {/* KPI Cards */}
      <div className="row">
        <div className="col-4 frame">
          <div className="d-flex justify-content-between align-items-start">
            <Skeleton width={100} height={16} />
            <Skeleton width={100} height={30} />
          </div>
          <Skeleton width={80} height={28} />
        </div>
        <div className="col frame">
          <Skeleton width={100} height={16} />
          <div className="d-flex justify-content-between">
            <Skeleton width={60} height={28} />
            <Skeleton circle width={24} height={24} />
          </div>
        </div>
        <div className="col frame">
          <Skeleton width={100} height={16} />
          <div className="d-flex justify-content-between">
            <Skeleton width={60} height={28} />
            <Skeleton circle width={24} height={24} />
          </div>
        </div>
        <div className="col frame mr-0">
          <Skeleton width={100} height={16} />
          <div className="d-flex justify-content-between">
            <Skeleton width={60} height={28} />
            <Skeleton circle width={24} height={24} />
          </div>
        </div>
      </div>

      {/* Upcoming Appointments Section */}
      <div className="d-flex justify-content-between mt-32 mb-16 pl-0 pr-0">
        <Skeleton width={150} height={20} />
        <Skeleton width={100} height={16} />
      </div>
      <div className="row gy-2 gx-3">
        <div className="col-6">
          <div className="frame" style={{ height: "169px" }}>
            <Skeleton width={100} height={16} />
            <Skeleton width={150} height={20} />
            <Skeleton width={200} height={16} />
            <Skeleton width={120} height={30} />
          </div>
        </div>
        <div className="col-6 pr-0">
          <div
            className="empty-frame mr-0 d-flex align-items-center justify-content-center"
            style={{ height: "169px" }}
          >
            <Skeleton width={250} height={16} />
          </div>
        </div>
      </div>

      {/* Pending Requests Section */}
      <div className="d-flex justify-content-between mt-32 mb-16 pl-0 pr-0">
        <Skeleton width={150} height={20} />
        <Skeleton width={150} height={16} />
      </div>
      <div className="row">
        <div className="col-6">
          <div className="frame ">
            <Skeleton width={100} height={16} />
            <Skeleton width={150} height={20} />
            <Skeleton width={200} height={16} />
            <Skeleton width={120} height={30} />
          </div>
        </div>
        <div className="col-6">
          <div className="frame  d-flex align-items-center justify-content-center">
            <Skeleton width={250} height={16} />
          </div>
        </div>
      </div>

      {/* Reviews Section */}
      <div className="d-flex justify-content-between mt-32 mb-16 pl-0 pr-0">
        <Skeleton width={150} height={20} />
        <Skeleton width={100} height={16} />
      </div>
      <div className="frame">
        <Skeleton width="100%" height={60} count={2} />
      </div>
    </>
  );
}

export default AccueilPrestaSkeleton;